import React from 'react'
import {OrderCardHeader, ProductListHeader} from '../shared'
import ProductListItem from './product/ProductListItem'

interface Props {
  items: Array<any>
  title?: string
  subTitle?: any
  children?: React.ReactNode
  toolbar?: any
  isShowStatus?: boolean
}

export const ViewOrderItems: React.FC<Props> = ({
  items,
  title = 'Products',
  subTitle,
  children,
  toolbar,
  isShowStatus,
}) => {
  return (
    <div className='card shadow-lg rounded-10 mb-7'>
      <OrderCardHeader title={title} subTitle={subTitle} itemsCount={items.length}>
        {toolbar}
      </OrderCardHeader>
      <ProductListHeader isShowStatus={isShowStatus}>
        {items.map((order, index) => {
          return <ProductListItem order={order} key={index} isShowStatus={isShowStatus} />
        })}
      </ProductListHeader>
      {children && <div className='card-footer'>{children}</div>}
    </div>
  )
}

export default ViewOrderItems
